<template>
  <div class="green__column">
    <div
        class="green__btn green__pointer green__see green__row green__ac green__mb__s"
    >
      <p>Выберите категорию</p>
    </div>
    <div class="item__column green__parents">
      <div
          v-if="!showCategorySkeleton"
          class="item__wrap item__ac">
        <div
            class=" item__row item__ac green__mb__xs green__parents green__pointer"
            v-for="(cat, c) in categories"
            :key="c"
            @click="getProductByCategory(c,cat.id, 'parent')"
        >
          <p
              :class="{'green__category__el': true, 'green__mr__xs': true, 'green__active' : c === current_category_index }"
          >
            {{ cat.name }}
          </p>
        </div>
      </div>

      <div
          v-else
          class="item__wrap item__ac"
      >
        <v-skeleton-loader type="actions"></v-skeleton-loader>
        <v-skeleton-loader type="actions"></v-skeleton-loader>
        <v-skeleton-loader type="actions"></v-skeleton-loader>
      </div>



      <div class="item__column" v-if="nested.length != 0">
        <div
            class="item__row item__ac green__mb__xs green__parents"
            v-for="(cat, c) in nested"
            :key="c"
        >
          <p class="green__category__el green__mr__xs">{{ cat.name }}</p>
          <v-tooltip bottom
          >
            <template v-slot:activator="{ on, attrs }"
            ><i
                class="mdi mdi-keyboard-return green__pointer"
                v-bind="attrs"
                v-on="on"
                @click="getProductByCategory(cat.id, 'child')"
            ></i></template
            >
            <span>Выбрать категорию</span></v-tooltip
          >
          <v-tooltip bottom
          >
            <template v-slot:activator="{ on, attrs }"
            ><i
                v-bind="attrs"
                v-on="on"
                class="mdi mdi-format-list-bulleted green__mr__xs green__pointer"

            ></i></template
            >
            <span>Показать список</span></v-tooltip
          >
        </div>
      </div>
    </div>

    <div class="green__column" v-if="showSkeleton">
      <v-skeleton-loader type="card-avatar, actions"></v-skeleton-loader>
      <v-skeleton-loader type="card-avatar, actions"></v-skeleton-loader>
      <v-skeleton-loader type="card-avatar, actions"></v-skeleton-loader>
      <v-skeleton-loader type="card-avatar, actions"></v-skeleton-loader>
    </div>

    <div class="green__column">
      <div
          class="green__column green__edit"
          v-for="(item, index) in products"
          :key="index"
      >
        <p class="green__data"><b>Название:</b> {{ item.name }}</p>

        <div class="item__row item__ac">
          <b>Описание:</b>
          &nbsp;
          <p v-html="item.description"></p>
        </div>
        <p class="green__data">
          <b>Создано:</b> {{ convert_date(item.created_at) }}
        </p>
        <p class="green__data"><b>Показать:</b>
          <v-switch
              v-model="item.show"
              hide-details
              inset
              :label="`показать на сайте: ${ item.show ? 'Да':'Нет' }`"
              @change="onChangeSwitch(item.show,item.id)"
          ></v-switch>
        </p>

        <div
            v-if="item.sizes.length !== 0"
            class="green__sizes mt-4"
        >
          <p class="mb-4"><b>Размеры:</b></p>
          <div
              class="green__size item__row item__ac  green__pointer"
              v-for="(size,size_index) in item.sizes" :key="size_index"
          >
            <div class="item__column">
              <p class="mr-2"><b>Размер:</b>&nbsp;&nbsp;{{ size.size }}</p>
              <p class="mr-2"><b>Рост:</b>&nbsp;&nbsp;{{ size.height }}</p>

              <div v-for="(file,file_index) in size.files" :key="file_index">
                <a :href="'https://api.kerimqoloner.kz/'+file.file_path" target="_blank" download>Файл<i class="mdi mdi-file"></i></a>
              </div>
            </div>

            <i @click="deleteParameter(item.category_id,size.id)" class="mdi mdi-delete-forever"></i>
          </div>
        </div>

        <!--          <div class="green__size">-->
        <!--            <p class="mr-2">Рост: </p>-->

        <!--            <div-->
        <!--                class="mb-2 item__row item__ac green__pointer mr-2"-->
        <!--                v-for="(height,height_index) in item.heights" :key="height_index">-->
        <!--              <p>{{ height.size }}</p>-->
        <!--              <i @click="deleteParameter(height.id)" class="mdi mdi-delete-forever"></i>-->
        <!--            </div>-->

        <!--          </div>-->

        <p class="green__images__title">Фотографий</p>

        <div class="item__row green__product__images__main">
          <div
              class="green__product__images green__row green__ac green__mr__xs"
              v-for="(image, i) in item.images"
              :key="i"
          >
            <img
                :src="'https://api.kerimqoloner.kz' + image.image_path"
                alt=""
            />
            <div
                @click="deletePhoto(item.category_id,image.id)"
            >
              <i class="mdi mdi-delete-forever"></i>
            </div>
          </div>
        </div>

        <div class="green__row green__ac">
          <div
              class="green__submit green__pointer green__row green__ac green__mb__s green__mr__xs"
              @click="openEditModal(index)"
          >
            <i class="fas fa-pencil-alt green__mr__xs"></i>
            <p>Редактировать</p>
          </div>

          <div
              class="green__submit green__pointer green__row green__ac green__mb__s"
              @click="deleteProduct(item.id)"
          >
            <i class="fas fa-trash-alt green__mr__xs"></i>
            <p>Удалить</p>
          </div>
        </div>
      </div>
    </div>


    <v-dialog v-model="open_edit_modal" max-width="500">
      <v-card class="pa-10">
        <form
            class="green__mb__s"
            @submit.prevent="editSave()"
        >
          <div class="green__column green__input">
            <p>Выберите категорию</p>
            <v-select
                v-model="category_id"
                :items="all_categories"
                item-text="name"
                item-value="id"
                label="Выберите категорию"
                outlined
            ></v-select>
          </div>



          <div
              v-for="(item_size,index) in configs"
              class="green__size--config"
              :key="index"
          >
            <div class="green__column green__input">
              <p>Выберите размер</p>
              <v-select
                  v-model="item_size.size"
                  :items="sizes"
                  label="Выберите размер"
                  outlined
              ></v-select>
            </div>

            <div class="green__column green__input">
              <p>Выберите рост</p>

              <v-select
                  v-model="item_size.height"
                  :items="heights"
                  label="Выберите рост"
                  outlined
              ></v-select>
            </div>

            <div class="green__column green__input">
              <p>PDF лекало</p>
              <v-file-input
                  chips
                  counter
                  multiple
                  small-chips
                  v-model="item_size.file"
                  outlined
              ></v-file-input>
            </div>

            <div
                @click="deleteConfig(index)"
                class="green__choose mb-4 green__pointer item__row item__ac"
            >
              <i class="mdi mdi-delete mr-1"></i>
              <p class="mb-0">Удалить лекало</p>
            </div>

          </div>

          <div
              @click="addConfig()"
              class="green__choose mb-4 green__pointer item__row item__ac"
          >
            <i class="mdi mdi-plus mr-1"></i>
            <p class="mb-0">Добавить лекало</p>
          </div>


          <div class="green__column green__input">
            <p>Название</p>
            <v-text-field
                v-model="name"
                label="Название"
                required
                outlined
            ></v-text-field>
          </div>

          <div class="green__column green__mr__xs green__input">
            <p>Цена</p>
            <v-text-field
                v-model="price"
                label="Цена"
                required
                outlined
            ></v-text-field>
          </div>

          <div class="green__column green__mr__xs green__input">
            <p>Цена со скидкой</p>
            <v-text-field
                v-model="price_sale"
                label="Цена"
                outlined
            ></v-text-field>
          </div>
          <div class="green__column green__input">
            <p class="green__mb__xs">Измерение</p>
            <v-select
                v-model="count_type"
                :items="count_types"
                item-text="name"
                item-value="id"
                label="Выберите измерение"
                outlined
                required
            ></v-select>
          </div>


          <div class="green__column green__input">
            <p>Описание</p>
            <v-textarea
                v-model="description"
                label="Описание"
                outlined
            ></v-textarea>
          </div>

          <div class="green__column green__input green__mb__s">
            <p>Добавить файл</p>
            <input type="file" multiple @change="uploadDoc"/>
          </div>

          <button class="green__submit" type="submit">
            <v-progress-circular
                v-if="createLoader"
                indeterminate
                color="white"
            ></v-progress-circular>
            <p v-else>Сохранить</p>
          </button>
        </form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

export default {
  data() {
    return {
      token: '',
      showCategorySkeleton: true,
      category_id: '',
      current_category_index: '',
      showSkeleton: '',
      category_type: '',
      categories: '',
      dialogApplication: '',
      message_notif: '',
      products: '',
      type_category: '',
      nested: '',
      createLoader: '',
      documents: [],
      count_type: 1,
      count_types: [
        {
          id: 1,
          name: "Шт",
        }
      ],
      price: '',
      price_sale: '',
      all_categories: [],
      open_edit_modal: false,
      name: '',
      description: '',
      configs: [
      ],

      height: [],
      heights: [
        'Стандарт', '154-160', '162-168', '170-176', '178-182', '184-190'
      ],
      size: [],
      sizes: ['Стандарт','42', '44', '46', '48', '50', '52', '54'],
    }
  },
  mounted() {
    this.token = localStorage.getItem('access_token')
    this.getCategories()
    this.getAllCategories()
  },
  methods: {
    deletePhoto(category_id,id) {
      const config = {
        headers: {Authorization: `Bearer ${localStorage.getItem('access_token')}`},
      }
      this.$http.delete("/delete/product/image?id="+id, config).then((res) => {
        this.$toast.open({
          message: res.data.message,
          type: "warning",
          position: "bottom",
          duration: 5000,
          queue: true,
        });
        this.getProductByCategory(this.current_category_index,category_id,null)
      })

    },
    getCategories() {
      const config = {
        headers: {Authorization: `Bearer ${this.token}`},
      };
      this.$http.get("/get/categories", config).then((res) => {
        this.categories = res.data;
        this.showCategorySkeleton = false

      });
    },
    getAllCategories() {
      const config = {
        headers: {Authorization: `Bearer ${this.token}`},
      };
      this.$http.get("/get/all/categories", config).then((res) => {
        this.all_categories = res.data;
      });
    },
    deleteProduct(id) {
      const confirmed = confirm("Удалить?");
      if (!confirmed) {
        return false
      }
      this.$http.delete("/delete/product?id="+id, {
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      })
          .then((res) => {
            this.$toast.open({
              message: res.data.message,
              type: "warning",
              position: "bottom",
              duration: 5000,
              queue: true,
            });
            this.getProductByCategory(this.current_category_index, this.category_id, null)
          });
    },
    deleteParameter(category_id,id) {

      this.category_id = category_id

      const confirmed = confirm("Удалить?");
      if (!confirmed) {
        return false
      }
      this.$http.delete("/delete/parameter/" + id, {
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      })
          .then((res) => {
            console.log(res.data)
            this.getProductByCategory(this.current_category_index, this.category_id, null)
          });
    },
    onChangeSwitch(show, productId) {
      let data = {
        show: show,
        id: productId
      };
      this.$http
          .post("/show/product", data, {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          })
          .then((res) => {
            this.$toast.open({
              message: res.data.message,
              type: "warning",
              position: "bottom",
              duration: 5000,
              queue: true,
            });

          })
          .catch((error) => {
            this.$toast.open({
              message: error.response.data.error,
              type: "error",
              position: "bottom",
              duration: 5000,
              queue: true,
            });
          });
    },
    convert_date(date) {
      if (date) {
        let day = date.split("T")[0].split("-")[2];
        let month = date.split("T")[0].split("-")[1];
        let year = date.split("T")[0].split("-")[0];

        let hour = date.split("T")[1].split(":")[0];
        let minute = date.split("T")[1].split(":")[1];
        let ready = day + "." + month + "." + year;

        return ready + " " + hour + ":" + minute;
      }
    },
    openEditModal(index) {
      this.open_edit_modal = true

      this.id = this.products[index].id
      this.name = this.products[index].name
      this.description = this.products[index].description
      this.price = this.products[index].price
      this.price_sale = this.products[index].price_sale ? this.products[index].price_sale : 0
      this.category_id = this.products[index].category_id

      this.count_type = this.products[index].count_type
      this.count = this.products[index].count


    },
    editSave() {

      console.log("documents:::::",this.documents)
      this.createLoader = true;
      let fd = new FormData();
      fd.append("id", this.id);
      fd.append("name", this.name);
      fd.append("category_id", this.category_id);
      fd.append("price", this.price);
      fd.append("price_sale", this.price_sale);

      fd.append("count", this.count);
      fd.append("count_type", this.count_type);

      fd.append('heights',JSON.stringify(this.height))
      fd.append('sizes',JSON.stringify(this.size))
      this.configs.forEach((item, index) => {
        fd.append(`configs[${index}][size]`, item.size);
        fd.append(`configs[${index}][height]`, item.height);
        if (item.file && item.file.length) {
          for (let i = 0; i < item.file.length; i++) {
            fd.append(`configs[${index}][files][]`, item.file[i]);
          }
        } else {
          console.warn(`No files found for config ${index}`);
        }
      });
      for (let i = 0; i < this.documents.length; i++) {
        fd.append("images[]", this.documents[i]);
      }
      console.log("documents",this.documents)
      fd.append("description", this.description);

      this.$http
          .post("/update/product", fd, {
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "multipart/form-data",
            }
          })
          .then((res) => {
            this.createLoader = false;
            this.$toast.open({
              message: res.data.message,
              type: "success",
              position: "bottom",
              duration: 5000,
              queue: true,
            });
            this.documents = [];
            this.message_notif = res.data.message;
            this.getCategories();
            this.getProductByCategory(this.current_category_index, this.category_id, null)
            this.open_edit_modal = false
            this.seePurchase = false;
            this.id = ''
            this.name = ''
            this.description = ''
            this.height = ''
            this.size = ''
            this.count = ''
            this.price = ''
            this.price_sale = ''
            this.count_type = ''
            this.category_id = ''
            this.count = ''

          })
          .catch((error) => {
            let errors = error.response.data.error;
            for (let variable in errors) {
              this.$toast.open({
                message: errors[variable][0],
                type: "error",
                position: "bottom",
                duration: 5000,
                queue: true,
              });
              continue;
            }
            this.documents = [];
          });
    },
    uploadDoc(e) {
      const file = e.target.files;
      for (let i = 0; i < file.length; i++) {
        this.documents.push(file[i]);
      }
    },
    deleteConfig(index) {
      this.configs.splice(index,1)
    },
    addConfig() {
      this.configs.push({ size: '',height: '',file:'' })
    },
    getProductByCategory(current_category_index, id, type = null) {
      this.current_category_index = current_category_index
      this.category_id = id;
      this.type_category = type;

      this.showSkeleton = true;
      let t = "";
      if (!type) {
        type = this.category_type;
      }
      this.choosen_type = type;

      if (this.type_category === "child") {
        t = this.nested.filter((item) => item.id == id);
      } else {
        t = this.categories.filter((item) => item.id == id);
      }
      console.log("there:",t)

      this.selected_category = t[0].name;
      this.dialogApplication = false;
      let data = {
        category_id: id,
      };
      this.$http
          .post("/get/products/admin/by/category", data, {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          })
          .then((res) => {
            this.message_notif = res.data.message;
            this.products = res.data;
            this.showSkeleton = false;
          });
    },
  }
}


</script>

<style scoped lang="less">
.admin__loader {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  z-index: 10;
  bottom: 0;
  background-image: linear-gradient(to right,
  #253532,
  #1e363d,
  #273345,
  #3c2e43,
  #4c2934);

  i {
    font-size: 36px;
    color: white;
  }

  p {
    font-size: 36px;
    color: white;
  }
}

@mobile: 900px;
@planshet: 1200px;
.mdi-logout {
  font-size: 26px;
  position: absolute;
  right: 20px;
  color: white;
  top: 20px;
}

.bonus__actions {
  width: 100%;
  z-index: 10;
  position: fixed;
  background: #191a21;
  bottom: 0;
  padding: 20px;

  .bonus__actions__btn {
    i {
      color: white;
      font-size: 32px;
    }
  }

  // p {
  //     padding: 15px;
  //     background-image: linear-gradient(to right, #131215, #1d161e, #2b1824, #3a1924, #481b20);
  //     border-radius: 20px;
  //     color: white;
  //     text-align: center;
  //     font-weight: bold;
  //     cursor: pointer;
  //     @media (max-width: @mobile) {
  //        padding: 10px;
  //        font-size: 14px;
  //     }
  // }
}

.modal__bonus {
  .modal__bonus__title {
    font-size: 22px;
    font-weight: bold;
    text-align: center;
    color: #4c2934;
  }

  .modal__bonus__result {
    margin-bottom: 10px;

    p {
      font-size: 18px;
      color: #0069ff;

      span {
        font-weight: bold;

        font-size: 20px;
      }
    }
  }

  .modal__bonus__label {
    margin-bottom: 15px;
  }

  input {
    padding: 10px;
    outline: none;
    border: 1px solid #ccc;
  }

  .modal__bonus__btn {
    border-radius: 20px;
    padding: 20px;
    text-align: center;
    justify-content: center;
    background-image: linear-gradient(to right,
    #253532,
    #1e363d,
    #273345,
    #3c2e43,
    #4c2934);

    p {
      color: white;
      font-weight: bold;
    }

    i {
      color: white;
    }
  }
}




.banners {
  overflow-x: scroll;

  i {
    cursor: pointer;
  }

  img {
    width: 100px;
    height: 100px;
    object-fit: cover;
  }
}

.green__notif_position {
  bottom: 200px;
}

p {
  margin-bottom: 0 !important;
}

.green__mb__xs {
  margin-bottom: 10px;
}

.green__mb__s {
  margin-bottom: 20px !important;
}

.green__ml__l {
  margin-left: 20px;
}

.green__mr__xs {
  margin-right: 10px;
}

.green__100 {
  width: 100%;
}

.green__row {
  display: flex;
  flex-direction: row;
}

.green__ac {
  align-items: center;
}

.green__jb {
  justify-content: space-between;
}

.green__column {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  @media (max-width: @mobile) {
    width: 100%;
  }
}

.green__abs {
  display: flex;
  justify-content: center;
  align-items: center;
}

.green__pointer {
  cursor: pointer;
}

.green__btn__color {
  color: #0069ff;
}

.green__btn__color:hover {
  opacity: 0.6;
}

.green__admin {
  min-height: 100vh;

  align-items: center;
  justify-content: center;

  .green__see {
    font-size: 18px;
    font-weight: bold;

    i {
      color: black !important;
    }
    @media (max-width: 900px) {
      font-size: 12px;
      white-space: nowrap;
    }
  }

  .green__see--active {
    color: #0069ff;
  }

  .green__images__title {
    margin-top: 40px;
    color: #0069ff;
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
  }

  .green__product__images__main::-webkit-scrollbar {
    height: 5px;
  }

  .green__product__images__main::-webkit-scrollbar-track {
    border-radius: 2px;
    background-color: #ccc;
  }

  .green__product__images__main::-webkit-scrollbar-thumb {
    background-color: #0069ff;
    border-radius: 2px;
    height: 24px;
    width: 50px;
  }

  .green__product__images__main {
    overflow-x: auto;
    width: 50%;
  }

  .green__product__images {
    margin-bottom: 20px;
    margin-top: 5px;
    position: relative;
    margin-right: 15px;


    img {
      width: 70px;
      height: 70px;
      border-radius: 10px;
      object-fit: cover;
      margin-right: 30px;
    }

    i {
       cursor: pointer;
       color: black !important;
       font-size: 14px;
       position: absolute;
       top: 0;
       right: 10px;
    }
    i:hover {
      opacity: 0.8;
    }
  }

  .green__logout {
    align-self: flex-end;
    padding: 10px;
    background-image: linear-gradient(to right,
    #253532,
    #1e363d,
    #273345,
    #3c2e43,
    #4c2934);
    color: white;
    margin-bottom: 20px;
    width: 140px;
    text-align: center;
  }

  .green__logout:hover {
    background: #5c8a0d;
  }

  .green__left {
    width: 20%;
    padding: 20px;
    background: #ffffff;
    box-shadow: 0px 8px 40px rgba(0, 0, 0, 0.05);
    border-radius: 2px;

    margin-right: 20px;
    min-height: 100px;
    border-radius: 10px;

    @media (max-width: @mobile) {
      width: 100%;
      margin-left: 0;
      margin-bottom: 20px;
    }

    p {
      font-weight: bold;
      cursor: pointer;
    }

    i {
      color: white;
    }
  }

  .green__right {
    padding: 20px;
    background: #ffffff;
    box-shadow: 0px 8px 40px rgba(0, 0, 0, 0.05);
    border-radius: 10px;


    i {
      color: white;
    }

    .green__parents {

      .green__category__el {
        border: 1px solid black;
        padding: 5px;
        margin-right: 20px;
        min-width: 100px;
        text-align: center;

        border-radius: 20px;
        box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
      }
      p {
        font-size: 16px;
      }

      i {
        background: #0069ff;
        padding: 10px;
        font-size: 22px;
        border-radius: 50%;
        margin-right: 10px;
      }

      i:hover {
        opacity: 0.8;
      }
    }

    .green__choose {
      margin-bottom: 20px;
      border: 1px solid black !important;

      .green__category__choose {
        cursor: pointer;
        padding: 20px;
        background: gray;
        margin-right: 10px;
        color: white;
        @media (max-width: @mobile) {
          font-size: 14px;
        }
        border-radius: 20px;
      }

      .green__category__active {
        background: #0069ff;
      }
    }

    .green__input {
      width: 300px;
      @media (max-width: @mobile) {
        width: 100%;
      }

      .green__input__write {
        border: 1px solid black;
        padding: 20px;
        border-radius: 2px;
        outline: none;
      }
    }

    button {
      width: 300px;
      outline: none;
      border: none;
      padding: 20px;
      background: #0069ff;
      color: white;
      @media (max-width: @mobile) {
        width: 100%;
      }
    }

    .green__edit {
      margin-bottom: 20px;
      border-radius: 2px;
      border: 1px solid #ccc;
      padding: 20px;

      a {
        color: #0069ff !important;
      }

      .green__user__orders {
        margin-top: 30px;
        margin-left: 10px;

        .green__user__title {
          font-weight: bold;
          font-size: 18px;
        }
      }

      @media (max-width: @mobile) {
        margin-left: 0;
      }

      .green__last__action {
        p {
          font-size: 12px;
        }
      }

      .green__data {
        margin-bottom: 10px;
        color: #0069ff;
        font-size: 18px;
      }

      .green__save__btn {
        color: #0069ff;
      }

      button {
        width: 300px;
        outline: none;
        border: none;
        background-color: #0069ff;
        color: white;
        padding: 20px;
        @media (max-width: @mobile) {
          width: 100%;
        }
      }
    }
  }
}

.green__message {
  button {
    outline: none;
    border: none;
    background-color: #0069ff;
    color: white;
    padding: 20px;
  }
}

.green__admin__inner {
  @media (max-width: @mobile) {
    flex-direction: column;
  }
}


.green__size {
  margin-top: 15px;
  margin-bottom: 15px;

  p {
    margin-bottom: 10px;
  }

  i {
    color: black !important;
  }
}

.green__submit {
  background: #0069ff;
  padding: 10px;
  color: white;
  width: 200px;

}

.green__column {
  p {
    font-weight: bold;
  }
}

.green__active {
  background: #0069ff;
  color: white;
  padding: 5px;

  i {
    color: white !important;
  }
}


.green__size--config {
  border: 1px solid black !important;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 20px;
}

.green__size {
  border: 1px solid black;
  padding: 10px;
  margin-bottom: 15px;
}


.green__choose {
  margin-bottom: 20px;
  border: 1px solid black;
  padding: 10px;
  min-width: 100px;

  .green__category__choose {
    cursor: pointer;
    padding: 20px;
    background: gray;
    margin-right: 10px;
    color: white;
    @media (max-width: @mobile) {
      font-size: 14px;
    }
    border-radius: 20px;
  }

  .green__category__active {
    background: #0069ff;
  }
}
</style>